import * as stylex from '@stylexjs/stylex'
import { type ElementType, type ReactNode } from 'react'
import { Box, type BoxProps } from '../Box/Box'
import { colors } from '../tokens/colors.stylex'

const baseStyles = stylex.create({
  ul: {
    marginBottom: 0,
    paddingLeft: 8,
  },
})

const NestedList = ({ list }: { list: ReactNode[] }) => {
  return (
    <ul {...stylex.props(baseStyles.ul)}>
      {list.map((item, index) => {
        return (
          Array.isArray(item)
            ? <NestedList list={item} key={`${item}-${index}`} />
            : <li key={`${item}-${index}`}>{item}</li>
        )
      })}
    </ul>
  )
}

export type UnorderedListProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = {
  list: ReactNode[] | ReactNode[][]
  color?: string
} & BoxProps<RootComponent, BoxElement>

export function UnorderedList<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(props: UnorderedListProps<RootComponent, BoxElement>) {
  const { component = 'div', list, color = colors.grey500, ...rest } = props

  return (
    <Box component={component} color={color} paddingLeft={2} {...rest}>
      <NestedList list={list} />
    </Box>
  )
}
